import PropTypes from 'prop-types';
import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import 'lazysizes';
import smoothScrollPolyFill from 'smoothscroll-polyfill';
import withRouter from 'react-router-dom/withRouter';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import TopBar from 'components/TopBar/TopBar';
import Footer from 'components/Footer/Footer';
import GDPR from 'components/GDPR/GDPR';
import Menu from 'components/TopBar/Menu';
import ContextMenu from 'components/ContextMenu/ContextMenu';
import Modal from 'components/Modal/Modal';
import getRoutes from 'config/routes';
import { ToastContainer, toast } from 'react-toastify';
import { hideCTXMenu } from 'redux/modules/contextMenu';
import { publicPaths } from 'config/constants';
import 'styles/style.css';

smoothScrollPolyFill.polyfill();

class AppContainer extends Component {
    static propTypes = {
        isAuthed: PropTypes.bool,
        isAdmin: PropTypes.bool,
        dispatch: PropTypes.func,
        profileData: PropTypes.object.isRequired,
        location: PropTypes.object,
        history: PropTypes.object,
    }

    componentWillMount() {
        this.publicPaths = publicPaths;
    }

    componentDidUpdate() {
        this.props.dispatch(hideCTXMenu());
    }

    render() {
        if (this.publicPaths.indexOf(this.props.location.pathname) !== -1) {
            return (
                <div id='outer-container'>
                    <TopBar isAdmin={true} location={this.props.location} isPublic={true}/>
                    <ErrorBoundary>
                        {getRoutes(this.props.isAuthed, true)}
                    </ErrorBoundary>
                    <ContextMenu/>
                    <Modal/>
                    <ToastContainer autoClose={5000} position={toast.POSITION.BOTTOM_LEFT} toastClassName='toaster-custom'/>
                    <Footer/>
                    <GDPR />
                </div>
            );
        }
        else {
            return (
                <div id='outer-container' className={this.props.isAuthed ? 'is-authed' : ''}>
                    <TopBar isAdmin={true} location={this.props.location}/>
                    {this.props.isAuthed ? <Menu isAdmin={true} location={this.props.location} profileData={this.props.profileData} /> : null}
                    <ErrorBoundary>
                        {getRoutes(this.props.isAuthed, false)}
                    </ErrorBoundary>
                    <ContextMenu/>
                    <Modal/>
                    <ToastContainer autoClose={5000} position={toast.POSITION.BOTTOM_LEFT} toastClassName='toaster-custom'/>
                    <Footer/>
                    <GDPR />
                </div>
            );
        }
    }
}

function mapStateToProps({ authentication }) {
    return {
        isAuthed: authentication.isAuthed,
        isAdmin: authentication.isAdmin,
        profileData: authentication.profileData
    };
}

export default withRouter(
    connect(
        mapStateToProps
    )(AppContainer)
);



// WEBPACK FOOTER //
// ./src/containers/App/AppContainer.js